module.exports = __webpack_public_path__ + "static/media/cloudedbanners.2281fc66.png";